import React from 'react';

import RuleSettingsModal from './rule-settings-modal';
import { useRuleSettings } from '../contexts/rule-settings-context';

import styles from './styles.module.scss';
import { I18n } from '@td/shared_utils';

const RulesSettingsContainer = () => {
  const { setModalIsOpen } = useRuleSettings();

  return (
    <React.Fragment>
      <a
        className={styles.editRulesLink}
        href="#"
        onClick={() => setModalIsOpen(true) }
      >
        <I18n scope="state_chart_review.config_form.modal" text="modal_trigger_label" />
      </a>
      <RuleSettingsModal />
    </React.Fragment>
  );
};

RulesSettingsContainer.propTypes = {};

export default RulesSettingsContainer;
